<template>
    <div class="col-xs-12 col-md-4 col-lg-4 col-xl-3 d-none d-xl-block">

        <ul class="m-profileMenu">
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'profil' }">
                    <span class="icon --profile"></span>Náš profil
                </router-link>
            </li>
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'kravicky' }">
                    <span class="icon --cows"></span>Naša kravička
                </router-link>
            </li>
            <li v-if="profil.pouzivatel_id && profil.pouzivatel_id.pouzivatel_group === 1" class="a-profileMenu__item">
                <router-link to="/skoly">
                    <span class="icon --bag"></span>Školská sekcia
                </router-link>
            </li>
            <li v-if="profil && profil.pouzivatel_id && profil.pouzivatel_id.pouzivatel_group === 0 && profil.pouzivatel_id.farma_pouzivatela.length != 0" class="a-profileMenu__item">
                <a :href="'https://www.adoptujkravicku.sk/hra/farma/moja-farma?'
                       + profil.pouzivatel_id.id + '&'
                       + profil.pouzivatel_id.pouzivatel_name + '&'
                       + profil.pouzivatel_email">
                    <span class="icon --farm"></span>Moja farma
                </a>
            </li>
            <li v-else-if="profil.pouzivatel_id.pouzivatel_group === 0" class="a-profileMenu__item">
                <router-link :to="{ name: 'vytvorenie-farmy' }">
                    <span class="icon --farm"></span>Moja farma
                </router-link>
            </li>
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'aktivita' }">
                    <span class="icon --activity"></span>Moja aktivita
                </router-link>
            </li>
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'album' }">
                    <span class="icon --stickers"></span>Náš album
                </router-link>
            </li>
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'statistiky' }">
                    <span class="icon --stats"></span>Štatistiky
                </router-link>
            </li>
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'spravy' }">
                    <span class="icon --messages"></span>Správy
                    <span v-if="typeof(spravy) !== 'undefined'" class="badge">{{ spravy }}</span>
                    <span v-else class="badge">0</span>
                </router-link>
            </li>
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'heslo' }">
                    <span class="icon --password"></span>Zmena hesla
                </router-link>
            </li>
            <li class="a-profileMenu__item">
                <router-link :to="{ name: 'udaje' }">
                    <span class="icon --userData"></span>Moje údaje
                </router-link>
            </li>
        </ul>
        <router-link :to="{ name: 'login', params: { reset: true } }" class="signOut">
            Odhlásiť sa <span class="icon"></span>
        </router-link>

    </div>
</template>



<script>
    export default {
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
        }
    }
</script>
